"use client";
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const proxy_client_react_1 = require("@unleash/proxy-client-react");
const utils_1 = require("./utils");
const FlagProvider = ({ children, ...props }) => ((0, jsx_runtime_1.jsx)(proxy_client_react_1.FlagProvider, { ...props, startClient: props.startClient !== undefined
        ? props.startClient
        : typeof window !== "undefined", config: {
        ...(0, utils_1.getDefaultClientConfig)(),
        ...props.config,
    }, children: children }));
exports.FlagProvider = FlagProvider;
